import styled, { css } from 'styled-components';
import { typography } from 'src/config/typography';
import { media } from 'src/config/breakpoints';

export const AuthTitle = styled.div`
  font-family: ${typography.fontFamilyHeaders};
  font-size: 1.5rem;
  grid-area: title;
  line-height: 1.875rem;

  ${media.w.between.px576.px992(css`
    text-align: center;
  `)};

  ${media.w.min.px992(css`
    font-size: 2.3125rem;
    line-height: 2.875rem;
  `)};
`;
